$(document).ready(function(){
  $('p.announcement-bar__message.h5').css('display', 'block');
$('.annoucement-slider').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});

// For homepage Product slider :-
  $('.mainslide').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: true,
   dots: true, // Added a comma here
   // fade: true,
   asNavFor: '.thumbnail-listt'
});
$('.thumbnail-listt').slick({
   slidesToShow: 4,
   slidesToScroll: 1,
   asNavFor: '.mainslide',
   dots: false,
   arrows: false,
   infinite: true,
   vertical: true,
   focusOnSelect: true,
   responsive: [
      {
         breakpoint: 1024,
         settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: false
         }
      },
      {
         breakpoint: 600,
         settings: {
            slidesToShow: 4, // Changed from 4 to 2
            slidesToScroll: 2,
            infinite: true,
            vertical: false
         }
      },
      {
         breakpoint: 480,
         settings: {
            slidesToShow: 4, // Changed from 4 to 1
            slidesToScroll: 1,
            infinite: true,
            vertical: false
         }
      }
   ]
});

 // $('.thumbnail-listt').slick({
 //   slidesToShow: 4,
 //   slidesToScroll: 1,
 //   asNavFor: '.mainslide',
 //   dots: false,
 //   arrows: false,
 //   infinite:true,
 //   vertical:true,
 //   focusOnSelect: true
 // });
// For homepage Product slider end.

// For Product slider :-
   setTimeout(function() {
$('.single-main-image').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
  infinite:true,
   arrows: true,
  dots: false,
   //fade: true,
   asNavFor: '.thumbanail-slider'
 });
 $('.thumbanail-slider').slick({
    slidesToShow: 4,
   slidesToScroll: 1,
   asNavFor: '.single-main-image',
   dots: false,
   arrows: false,
   infinite:true,
   vertical:true,
   focusOnSelect: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 2,
        infinite: true,
        vertical:false,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        vertical:false,
      }
    }

  ]
});

    }, 0);
 //   $('.thumbanail-slider').slick({
 //   slidesToShow: 4,
 //   slidesToScroll: 1,
 //   asNavFor: '.single-main-image',
 //   dots: false,
 //   arrows: false,
 //   infinite:true,
 //   vertical:true,
 //   focusOnSelect: true
 // });

// For Product slider end


  // For Product2 slider :-
$('.first-main-image').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
  infinite:true,
   arrows: true,
  dots: false,
   //fade: true,
   asNavFor: '.thumb-image'
 });
   $('.thumb-image').slick({
   slidesToShow: 3,
   slidesToScroll: 1,
   asNavFor: '.first-main-image',
   dots: false,
   arrows: false,
   infinite:true,
   vertical:false,
   focusOnSelect: true
 });

// For Product2 slider end

  // For Product3 slider :-
 $('.mainslide2').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: true,
  dots: false,
   //fade: true,
   asNavFor: '.thumbnail-listt2'
 });
 $('.thumbnail-listt2').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   asNavFor: '.mainslide2',
   dots: false,
   arrows: false,
   infinite:true,
   vertical:false,
   focusOnSelect: true
 });
// For Product3 slider end
  $('.review-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});
  
});
  


$('button.video-1').click(function(){

    $('iframe#secvideo').attr('src','');
     $('iframe#secvideo').attr('src','https://www.youtube.com/embed/DWriP-SQdU0');
});

$('iframe#video1 button.ytp-large-play-button.ytp-button.ytp-large-play-button-red-bg').click(function(){
  alert('dzfdsf');
  });

$('button.video-2').click(function(){

    $('iframe#video1').attr('src','');
     $('iframe#video1').attr('src','https://www.youtube.com/embed/Op4uBRt2wfc');
});

